import axios from "axios";

const API_URL = "https://iudi-api.thinkdiff.us/api/listings";

/**
 * Hàm lấy danh sách tin đăng từ API, hỗ trợ phân trang
 * @param {number} page - Số trang muốn lấy
 * @param {number} limit - Số lượng tin trên mỗi trang
 * @returns {Promise<Array>} - Một mảng các tin đăng
 */
export const getListings = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(API_URL, {
      params: { page, limit },
    });
    const data = response?.data;

    // Chuẩn hoá nhiều dạng cấu trúc trả về khác nhau từ API
    // Trả về mảng listings nếu có, nếu không thử items, data, hoặc chính data là mảng
    const listings = Array.isArray(data)
      ? data
      : data?.listings || data?.items || data?.data || [];

    return Array.isArray(listings) ? listings : [];
  } catch (error) {
    console.error("Lỗi dữ liệu:", error);
    // Ném lỗi ra để hook có thể bắt và xử lý
    throw error;
  }
};

/**
 * Lấy listings theo CategoryID (filter phía server)
 * @param {number} categoryId - ID của category
 * @param {number} page - Số trang
 * @param {number} limit - Số lượng items
 * @returns {Promise<Array>}
 */
export const getListingsByCategory = async (
  categoryId,
  page = 1,
  limit = 20
) => {
  try {
    const response = await axios.get(`${API_URL}`, {
      params: {
        CategoryId: categoryId,
        page,
        limit,
      },
    });
    const data = response?.data;
    const listings = Array.isArray(data)
      ? data
      : data?.listings || data?.items || data?.data || [];
    return Array.isArray(listings) ? listings : [];
  } catch (error) {
    console.error("Lỗi lấy listings theo category:", error);
    throw error;
  }
};

export const searchListings = async (
  text,
  category_id,
  parent_id,
  page = 1,
  limit = 10
) => {
  try {
    const response = await axios.get(`${API_URL}/search`, {
      params: { text, category_id, parent_id, page, limit },
    });
    const data = response?.data;
    const listings = Array.isArray(data)
      ? data
      : data?.listings || data?.items || data?.data || [];
    return Array.isArray(listings) ? listings : [];
  } catch (error) {
    console.error("Lỗi dữ liệu:", error);
    throw error;
  }
};
